import React, { useEffect, useState } from 'react';

import { withGoogleAnalyticsClickEvent, GoogleAnalyticsConstants } from '@vvoyages/google-analytics';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';

type CheckBoxType = {
  name: string;
  label: string;
  onChange: Function;
  value?: boolean | string;
  className?: string;
};

const Checkbox = React.forwardRef<HTMLInputElement, CheckBoxType>(
  ({ name, label, value, onChange, className = '' }: CheckBoxType, ref) => {
    const [isChecked, setIsChecked] = useState(value);

    useEffect(() => {
      setIsChecked(value);
    }, [value]);

    const changeHandler = () => {
      onChange(!isChecked);
      setIsChecked(!isChecked);
    };

    const checkboxContainerClasses = classNames({
      [styles.checkbox]: className?.includes('checkdisable') !== true,
      [className]: !!className,
    });

    return (
      <div className={checkboxContainerClasses}>
        <div className={styles.inputContainer}>
          <input
            id={name}
            name={name}
            type="checkbox"
            onChange={changeHandler}
            min={1}
            className={styles.inputSection}
            autoComplete="off"
            step="any"
            ref={ref}
          />
          {isChecked && <span className={classNames(styles.checkboxCustom)} />}
        </div>
        {label && (
          <label htmlFor={name} className={classNames(styles.checkbox__label, styles.labelCheckbox)}>
            {label}
          </label>
        )}
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';
export default withGoogleAnalyticsClickEvent(
  Checkbox,
  (props: { checked: boolean; label: string }) =>
    props.checked
      ? GoogleAnalyticsConstants.EVENT_ACTION.CHECKBOX_DESELECTED
      : GoogleAnalyticsConstants.EVENT_ACTION.CHECKBOX_SELECTED,
  (props: { checked: boolean; label: string }) => props.label,
);
